import { VehicleCondition } from "./Vehicle.types";

export interface LeadDto {
  id?: string;
  teamId: string;
  vehicleId: string;
  creationTime: string;
  lastModificationTime: string;
  leadOrigin: LeadOrigin;
  status: LeadStatus;
  hasTradeInVehicle: boolean;
  message: string;
  vehicle: VehicleOfInterest;
  contact: Contact;
  simulation?: Simulation;
}
export interface VehicleOfInterest {
  id: string;
  price: number;
  manufactureYear: number;
  modelYear: number;
  condition: VehicleCondition;
  kilometers: number;
  version: string;
  make: string;
  plate: string;
  model: string;
}

export interface Contact {
  name: string;
  email: string;
  phone: string;
}

export interface Simulation {
  initialAmount: number;
  totalInstallments: number;
  monthlyPayment: number;
  customerCreditStatus: any;
  loanAmount: number;
}

export enum LeadOrigin {
  SEARCH_SIMULATION = "SEARCH_SIMULATION",
}

export enum LeadStatus {
  RECEIVED = "RECEIVED",
}
